/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tame_Tame_Quail_TiltInputs */

const en_tame_tame_quail_tilt = /** @type {(inputs: Tame_Tame_Quail_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

const de_tame_tame_quail_tilt = /** @type {(inputs: Tame_Tame_Quail_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Tame_Tame_Quail_TiltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tame_tame_quail_tilt = /** @type {((inputs?: Tame_Tame_Quail_TiltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tame_Tame_Quail_TiltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tame_tame_quail_tilt(inputs)
	return de_tame_tame_quail_tilt(inputs)
});